import { SmartTable, SmartTableColumn } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ScenarioPastEpisodesData } from '~/stores/use-chat/use-chat.types';
import {
  getPastEpisodesCount,
  getTradingDaysCount,
} from '~/utils/domino-utils/domino-utils';

import * as S from '../../PastEpisodesWidget.styles';

type EpisodeTableRow = {
  key: string;
  episodeNo: number;
  date: string;
  tradingDays: number;
};

export const ScenarioPastEpisodes = ({ episode }: ScenarioPastEpisodesData) => {
  const { t } = useTranslation('widget');

  const pastEpisodesCount = getPastEpisodesCount(episode);
  const tradingDaysCount = getTradingDaysCount(episode);

  const pastEpisodesMapped: EpisodeTableRow[] = episode.dates.map(
    (episode, index) => ({
      key: `episodeTable-${index}`,
      episodeNo: index + 1,
      date: episode.date,
      tradingDays: episode.data?.length ?? 0,
    })
  );

  const columns: SmartTableColumn<EpisodeTableRow>[] = [
    {
      label: t('widget:pastEpisode.table.episodeNo'),
      key: 'episodeNo',
    },
    {
      label: t('widget:pastEpisode.table.episodeDate'),
      key: 'date',
    },
    {
      label: t('widget:pastEpisode.table.tradingDays', {
        totalTradingDays: tradingDaysCount,
      }),
      key: 'tradingDays',
    },
  ];

  return (
    <>
      <S.Title data-testid="episode-description">
        {t('widget:pastEpisode.title', {
          episodes: pastEpisodesCount,
          totalTradingDays: tradingDaysCount,
        })}
      </S.Title>
      <SmartTable columns={columns} data={pastEpisodesMapped} />
    </>
  );
};
